import { Row } from "react-bootstrap";
import uuid from "react-uuid";

import { useWorkflow } from "../../context/WorkflowContext";

import Pagination from "../../components/Pagination";
import WorkflowItem from "./components/WorkflowItem";
import EmptyWorkflow from "./components/EmptyWorkflow";
import { WorkflowType } from "../../context/interfaces/IWorkflowContext";

const Results = () => {
    const {
        workflows,
        pagination,
        workflowFilter,
        setWorkflowFilter,
        filterWorkflows,
    } = useWorkflow();

    const handleChangePage = (actualPage: number) => {
        const filter = {
            ...workflowFilter,
            actualPage,
        };

        setWorkflowFilter(filter);
        filterWorkflows(filter);
    };

    const paginatedWorkflows = (
        <Pagination
            pagination={pagination}
            filterPageSize={workflowFilter.pageSize}
            handleChangePage={handleChangePage}
        >
            {workflows.map((workflow: WorkflowType) => (
                <WorkflowItem key={uuid()} workflow={workflow} />
            ))}
        </Pagination>
    );

    return (
        <Row
            style={{
                paddingTop: 25,
                paddingLeft: 15,
                paddingRight: 15,
            }}
        >
            {workflows.length ? paginatedWorkflows : <EmptyWorkflow />}
        </Row>
    );
};

export default Results;
